// extracted by mini-css-extract-plugin
module.exports = {"profileForm":"MyAccount_profileForm__2ZB65","profileDetails":"MyAccount_profileDetails__10zIN"};